module.exports = __webpack_public_path__ + "static/iconography-metaphor-do-92a35bc0924d368ecc54ff2c0eb27bb8.png";